import { render, staticRenderFns } from "./OrderCarItem.vue?vue&type=template&id=613f388a&scoped=true&"
import script from "./OrderCarItem.vue?vue&type=script&lang=js&"
export * from "./OrderCarItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderCarItem.vue?vue&type=style&index=0&id=613f388a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f388a",
  null
  
)

export default component.exports